// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
import * as tslib_1 from "tslib";
// THIS FILE WAS AUTOGENERATED
import { Domain } from './Domain';
/**
 * An instance of Remote Dependency represents an interaction of the monitored component with a remote component/service like SQL or an HTTP endpoint.
 */
var RemoteDependencyData = /** @class */function (_super) {
  tslib_1.__extends(RemoteDependencyData, _super);
  function RemoteDependencyData() {
    var _this = _super.call(this) || this;
    _this.ver = 2;
    _this.success = true;
    _this.properties = {};
    _this.measurements = {};
    return _this;
  }
  return RemoteDependencyData;
}(Domain);
export { RemoteDependencyData };
